export default __webpack_public_path__ + "295748a9b0400fb267020d1a6b2abebd.png";